"use strict";

theme.predictiveSearch = (function () {
  var currentString = "";
  var isLoading = false;
  var searchTimeout;
  var namespace = ".predictive";

  var selectors = {
    form: "#HeaderSearchForm",
    input: 'input[type="search"]',
    wrapper: "#PredictiveWrapper",
    resultDiv: "#PredictiveResults",
    searchButton: "[data-predictive-search-button]",
  };

  var cache = {};
  var config = {
    imageSize: "square",
  };

  var classes = {
    isActive: "predicitive-active",
  };

  var keys = {
    up_arrow: 38,
    down_arrow: 40,
    tab: 9,
  };

  function init() {
    // Only some languages support predictive search
    if (document.getElementById("shopify-features")) {
      var supportedShopifyFeatures = JSON.parse(
        document.getElementById("shopify-features").innerHTML,
      );
      if (!supportedShopifyFeatures.predictiveSearch) {
        return;
      }
    }

    cache.wrapper = document.querySelector(selectors.wrapper);

    if (!cache.wrapper) {
      return;
    }

    config.imageSize = cache.wrapper.dataset.imageSize;

    cache.form = document.querySelector(selectors.form);
    cache.form.setAttribute("autocomplete", "off");
    cache.form.on("submit" + namespace, submitSearch);

    cache.input = cache.form.querySelector(selectors.input);
    cache.input.on("keyup" + namespace, handleKeyup);

    cache.submit = cache.wrapper.querySelector(selectors.searchButton);
    cache.submit.on("click" + namespace, triggerSearch);

    cache.results = document.querySelector(selectors.resultDiv);
  }

  function reset() {
    cache.wrapper.classList.add("hide");
    cache.results.innerHTML = "";
    clearTimeout(searchTimeout);
  }

  function triggerSearch() {
    cache.form.submit();
  }

  // Append * wildcard to search
  function submitSearch(evt) {
    evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);

    var obj = {};
    var formData = new FormData(evt.target);
    for (var key of formData.keys()) {
      obj[key] = formData.get(key);
    }

    if (obj.q) {
      obj.q += "*";
    }

    var params = paramUrl(obj);

    window.location.href = `${theme.routes.search}?${params}`;
    return false;
  }

  function handleKeyup(evt) {
    if (evt.keyCode === keys.up_arrow) {
      return;
    }

    if (evt.keyCode === keys.down_arrow) {
      return;
    }

    if (evt.keyCode === keys.tab) {
      return;
    }

    search();
  }

  function search() {
    var keyword = cache.input.value;

    if (keyword === "") {
      reset();
      return;
    }

    var q = _normalizeQuery(keyword);

    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(
      function () {
        predictQuery(q);
      }.bind(this),
      500,
    );
  }

  function predictQuery(q) {
    if (isLoading) {
      return;
    }

    // Do not re-search the same thing
    if (currentString === q) {
      return;
    }

    currentString = q;
    isLoading = true;

    var searchObj = {
      q: q,
      "resources[type]": theme.settings.predictiveSearchType,
      "resources[limit]": 4,
      "resources[options][unavailable_products]": "last",
      "resources[options][fields]":
        "title,product_type,variants.title,vendor",
    };

    var params = paramUrl(searchObj);

    fetch("/search/suggest.json?" + params)
      .then((response) => response.json())
      .then((suggestions) => {
        isLoading = false;
        var data = {};
        var resultCount = 0;

        cache.wrapper.classList.remove("hide");
        var resultTypes = Object.entries(suggestions.resources.results);

        Object.keys(resultTypes).forEach(function (i) {
          var obj = resultTypes[i];
          var type = obj[0];
          var results = obj[1];
          resultCount += results.length;

          switch (type) {
            case "products":
              data[type] = buildProducts(results);
              break;
            case "collections":
              data[type] = buildCollections(results);
              break;
            case "pages":
              data[type] = buildPages(results);
              break;
            case "articles":
              data[type] = buildArticles(results);
              break;
          }
        });

        if (resultCount === 0) {
          reset();
          return;
        }

        // Build and append result markup
        var output = buildOutput(data);
        cache.results.innerHTML = "";
        cache.results.innerHTML = output;
        theme.lazyImages();
      });
  }

  function buildProducts(results) {
    var output = "";
    var products = [];

    results.forEach((product) => {
      var new_product = {
        title: product.title,
        url: product.url,
        image_responsive_url: theme.Images.lazyloadImagePath(product.image),
        image_aspect_ratio: product.featured_image.aspect_ratio,
      };

      products.push(new_product);
    });

    if (products.length) {
      var markup = theme.buildProductGridItem(
        products,
        "small--one-half medium-up--one-quarter",
        4,
        config.imageSize,
      );

      output = `
        <div data-type-products>
          <div class="grid grid--uniform">
            ${markup}
          </div>
        </div>
      `;
    }

    return output;
  }

  function buildCollections(collections) {
    var output = "";

    if (collections.length) {
      var markup = theme.buildCollectionItem(collections);

      output = `
        <div data-type-collections>
          <p class="h6 predictive__label">${theme.strings.searchCollections}</p>
          <ul class="no-bullets">
            ${markup}
          </ul>
        </div>
      `;
    }

    return output;
  }

  function buildPages(pages) {
    var output = "";

    if (pages.length) {
      var markup = theme.buildPageItem(pages);

      output = `
        <div data-type-pages>
          <p class="h6 predictive__label">${theme.strings.searchPages}</p>
          <ul class="no-bullets">
            ${markup}
          </ul>
        </div>
      `;
    }

    return output;
  }

  // Overwrite full sized image returned form API
  // with lazyloading-friendly path
  function buildArticles(articles) {
    var output = "";

    articles.forEach((article) => {
      if (article.image) {
        article.image = theme.Images.getSizedImageUrl(
          article.image,
          "200x200_crop_center",
        );
      }
    });

    if (articles.length) {
      var markup = theme.buildArticleItem(articles, config.imageSize);

      output = `
        <div data-type-articles>
          <p class="h6 predictive__label">${theme.strings.searchArticles}</p>
          <div class="grid grid--uniform">
            ${markup}
          </div>
        </div>
      `;
    }

    return output;
  }

  // Combine all search result markup and print to page
  function buildOutput(data) {
    var output = "";

    if (data.products && data.products !== "") {
      output += data.products;
    }

    if (data.collections && data.collections !== "") {
      output += data.collections;
    }

    if (data.pages && data.pages !== "") {
      output += data.pages;
    }

    if (data.articles && data.articles !== "") {
      output += data.articles;
    }

    return output;
  }

  function _normalizeQuery(string) {
    if (typeof string !== "string") {
      return null;
    }

    return string.trim().replace(/\ /g, "-").toLowerCase();
  }

  function paramUrl(obj) {
    return Object.keys(obj)
      .map(function (key) {
        return key + "=" + encodeURIComponent(obj[key]);
      })
      .join("&");
  }

  return {
    init: init,
  };
})();

theme.buildPageItem = function (items) {
  var output = "";

  items.forEach((page) => {
    var markup = `
      <li>
        <a href="${page.url}">
          ${page.title}
        </a>
      </li>
    `;

    output += markup;
  });

  return output;
};

theme.buildArticleItem = function (items, imageSize) {
  var output = "";

  items.forEach((article) => {
    var image = theme.buildPredictiveImage(article);
    var markup = `
      <div class="grid__item grid-product small--one-half medium-up--one-quarter" data-aos="row-of-4">
        <a href="${article.url}" class="grid-product__link grid-product__link--inline">
          <div class="grid-product__image-mask">
            <div
              class="grid__image-ratio grid__image-ratio--object grid__image-ratio--${imageSize}">
              <div class="predictive__image-wrap">
                ${image}
              </div>
            </div>
          </div>
          <div class="grid-product__meta">
            ${article.title}
          </div>
        </a>
      </div>
    `;

    output += markup;
  });

  return output;
};

theme.buildPredictiveImage = function (obj) {
  var imageMarkup = "";
  if (obj.image) {
    imageMarkup = `<img class="js-lazyimage" src="${obj.image}" loading="lazy">`;
  }
  return imageMarkup;
};

